module.exports = __webpack_public_path__ + "img/main-page.283de106.svg";